import { useMemo } from "react";
import { useApi, apiResolver } from "@/api/useApi";
import { InteractionEventResponse } from "./InteractionEvent.model";

export function useInteractionEventApi() {
  const { api } = useApi();

  return useMemo(
    () => ({
      getInteractionEvents: (ticketId: string, isTicket: boolean) =>
        apiResolver<InteractionEventResponse>(
          api.get(
            `/platform/interaction-events/${ticketId}?isTicket=${isTicket}`
          )
        ),
    }),
    [api]
  );
}
